export default __webpack_public_path__ + "static/media/Tools-P18-CIFOR.1df460a1.jpg";